import { Pipe, PipeTransform } from '@angular/core';
import { round } from 'lodash';

const K = Math.pow(2, 10);
const M = Math.pow(2, 20);
const G = Math.pow(2, 30);

@Pipe({
  name: 'byte'
})
export class BytePipe implements PipeTransform {
  transform(value: number): string {
    const g = Math.floor(value / G);
    const m = Math.floor(value / M);
    const k = Math.floor(value / K);
    return g ? g + 'GB' : m ? m + 'MB' : k ? k + 'KB' : round(value, 2) + 'B';
  }
}
